import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import DashboardSideNav from '../components/dashboardSidenav';
import DashboardHeader from '../components/dashboardHeader';
import Statistics from '../components/statistics';
import Profile from '../components/profile';
import DashboardSummary from '../components/dashboardSummery';

const ProfilePage = () => {
    return (
        <div className="dashboard-container">
            {/* Sidebar */}
            <DashboardSideNav />

            {/* Main Content */}
            <div className="main-content">
                <DashboardHeader />

                <Container fluid>
                    <Row>
                        {/* Left Column */}
                        <Col lg={9}>
                            <DashboardSummary />
                            <Profile />
                        </Col>

                        {/* Right Column */}
                        <Col lg={3}>
                            <Statistics preview={true} />
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
};

export default ProfilePage;
